"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formatters = require("../../../utils/formatters");
var _dateFns = require("date-fns");
var _reactI18next = require("react-i18next");
require("./DateDivider.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var DateDivider = function DateDivider(_ref, _ref2) {
  var index = _ref.index,
    lang = _ref.lang,
    date = _ref.date;
  var _useTranslation = (0, _reactI18next.useTranslation)(['chat']),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: function ref(el) {
      return _ref2.current[index] = el;
    },
    className: "uin-date-divider"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-date-divider-container"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-date-divider-span"
  }, (0, _dateFns.isToday)(date) ? t("divider-today") : (0, _dateFns.isYesterday)(date) ? t("divider-yesterday") : (0, _formatters.formatDateWithDayOfWeek)(date, lang))));
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(DateDivider);


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/common/DateDivider/DateDivider.js
// module id = 1432
// module chunks = 0